// spinner.token.ts
import {HttpContextToken} from '@angular/common/http';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);
